module.exports = {
  type: 'spa',
  isTenanted: true,
  publicPath: '/fl-quote-launcher/',
  octopusPackageId: 'fl-quote-launcher',
  octopusProjectName: 'FL Quote Launcher',
  mountDOMId: 'fl-launcher-app',
  standalone: true
};